import React, { useCallback, useState, useMemo } from 'react';
import { ToastContainer } from '../ui/kit/feedback/ToastContainer';
import { ToastContext } from '../contexts/ToastContext';
import type { 
    ToastType, 
    ToastOptions,
    Toast 
} from '../lib/toast.types';

let toastIdCounter = 0;

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [toasts, setToasts] = useState<Toast[]>([]);

    const showToast = useCallback((message: string, type: ToastType = 'info', options?: ToastOptions) => {
        const id = `toast-${++toastIdCounter}-${Date.now()}`;
        
        const newToast: Toast = {
            id,
            type,
            message,
            duration: options?.duration ?? 3000,
            action: options?.action,
        };

        setToasts(prev => [...prev, newToast]);
        
        return id;
    }, []);

    const removeToast = useCallback((id: string) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    }, []);

    const value = useMemo(() => ({
        showToast,
        removeToast,
        toasts,
    }), [showToast, removeToast, toasts]);

    return (
        <ToastContext.Provider value={value}>
            {children}
            <ToastContainer toasts={toasts} onRemove={removeToast} />
        </ToastContext.Provider>
    );
};